const jordan = "/_app/immutable/assets/jordan.BnQYPCuQ.png";
export {
  jordan as default
};
